import React, {useEffect, useCallback, useState} from 'react'
import {Switch, Route} from 'react-router-dom'
import {observer} from 'mobx-react-lite'
import {userStore, categoryStore} from '../../stores/store'
import {AppStyle} from './styles'
import Simple from '../../pages/simple'
import Main from '../../pages/main'
import Aside from '../../pages/aside'
import FixFoot from '../../components/fix_foot'


const App = observer(() => {

    const [isHeaderType, setIsHeaderType] = useState('');
    const [isHiddenFixfoot, setIsHiddenFixfoot] = useState(false);

    // 22-08-09 simple 헤더 노출하고 싶을 경우
    // let header_type = 'simple'

    const host = window.location.hostname.split('.')[0]
    const hostPathName = window.location.pathname

    const prefixUrl = window.location.origin.replace(':3000','')
    const postfixUrl = hostPathName.length > 1 ? hostPathName : ''
    const URL = prefixUrl + postfixUrl

    const mainView = host !== 'search'

    //22-08-19 상단 헤더를 숨김 처리할 host를 배열에 입력
    const HIDDEN_HEADER = ['cart','order']

    /**
     * 22-08-25 fix_foot(하단 내비)을 숨김 처리할 URL을 배열에 입력
     * @type {(string|string)[]}
     */
    const HIDDEN_FIXFOOT = [
        `https://pc.pping.${process.env.REACT_APP_TLD}`,
        `https://cart.pping.${process.env.REACT_APP_TLD}/service/`,
        `https://shopping.pping.${process.env.REACT_APP_TLD}/list/`,
        `https://shopping.pping.${process.env.REACT_APP_TLD}/detail/`,
        `https://notebook.pping.${process.env.REACT_APP_TLD}`,
        `https://shopping.pping.${process.env.REACT_APP_TLD}`,
    ]

    const isShowFixfoot = (URL,HIDDEN_FIXFOOT ) => {
        const arr = HIDDEN_FIXFOOT.filter((item)=>(URL.includes(item)))
        return arr.length > 0
    }

    useEffect(() => {
        fetchCategory()
        fetchUser()
        setIsHeaderType(window.HEADER_TYPE)

        // shopping.pping detail의 경우 window.HEADER_TYPE 이 search로 되어 있음
        // 그래서 host와 경로를 이용해 isHeaderType을 simple로 변환 처리
        if (host === 'shopping' && hostPathName.includes('detail')) {
            setIsHeaderType('simple')
        }

        setIsHiddenFixfoot(isShowFixfoot(URL,HIDDEN_FIXFOOT))


    }, [])

    const fetchCategory = useCallback(() => {
        categoryStore.cateRequest()
    }, [])

    const fetchUser = useCallback(() => {
        userStore.setUser()
    }, [])


    return (
        <AppStyle>
            <Route path="*" component={Aside}/>
            {/*상단 모바일 헤더*/}
            {HIDDEN_HEADER.includes(host)
                ? <></>
                : (isHeaderType === 'simple'
                    ? <Simple host={host} hostPathName={hostPathName} URL={URL}/>
                    : (<Switch> {mainView && <Route path="*" component={Main}/>}
                    </Switch>))
            }
            {/*하단 내비게이션*/}
            {isHiddenFixfoot
                ? <></>
                : <Route path="*" component={FixFoot}/>

            }
        </AppStyle>
    )
})

export default App



// WEBPACK FOOTER //
// ./src/m_header/layouts/app/index.js